export default __webpack_public_path__ + "static/media/loadingSpinner.0c36c7e3.svg";